export default {
  active: null,
  last_table_height: null,
  category: null,
  model: null,
  selected_catalog: null
}



// WEBPACK FOOTER //
// ./src/store/state.js